module.exports = __webpack_public_path__ + "public/img/Sale06.b57a661e.png";